<template>
  <div class="container">
    <div class="theme">
      <p class="agreement_title">货车及专项作业车ETC用户协议</p>
      <p>甲方：(发行服务机构)</p>
      <p>乙方：(开户人)</p>
    </div>
    <span class="legal">根据《中华人民共和国合同法》等有关法律、法规规定，甲方向社会公开发行ETC车载设备，甲方为乙方提供联网收费公路通行费电子支付服务以及法律所允许的相关支付服务，甲乙双方在平等、自愿、公平、诚实、互信的基础上，就ETC车载设备的办理和使用达成如下协议，共同信守。</span>
    <div class="agreement_item">
      <p class="mar_no">一、定义</p>
      <span>1、ETC采用实名制，甲方为乙方(个人或单位)开立ETC账户，发行ETC记账卡，卡内不记录资金信息，其车辆在通过联网高速公路或已联网的普通公路时，或在已开通的第三方应用场景交易时，系统根据交易记录在乙方ETC账户中记账，通过乙方绑定的支付账户划转消费金额。</span>
      <span>2、电子标签是记载车辆信息，与ETC车道内安装的专用设备进行通讯的车载设备。电子标签需与ETC账户配合使用，方可在ETC车道通行，实现不停车交费。</span>
    </div>
    <div class="agreement_item">
      <p class="mar_no">二、甲方的权利和义务</p>
      <span>1、甲方负责电子标签和ETC记账卡的发行、账户绑定、结算、客服等业务，并在发行中遵守行业规定的相关发行规则，与高速公路经营管理单位共同保障ETC系统及第三方应用场景系统正常运营。</span>
      <span>2、甲方向乙方发行电子标签和ETC记账卡，电子标签符合GB/T20851.1~4—2007《电子收费专用短程通信》系列标准。</span>
      <span>3、甲方负责为乙方提供账户管理、交易记录查询、信息变更、挂失更换等售后服务。</span>
      <span>4、甲方确保电子收费系统交易数据真实、有效，对于因交易数据延时、缺失等造成客户欠缴、少缴通行费的，甲方保留追缴的权利，且不因乙方销户而丧失。</span>
      <span>5、甲方承诺对乙方办理相关业务时提供的资料信息以及消费数据保密。</span>
      <span>6、甲方有权根据有关规定采取有效方式对乙方进行客户身份识别，将乙方的信息传输至相关政府部门、金融机构及其他有权机关单位等，以校验乙方个人信息的真实性，核实乙方真实身份。</span>
      <span>7、甲方根据法律、行政法规等规定而须予以依法披露的情形以及甲方依据本协议而采取维护其权利的行为，包括但不限于向第三方提供乙方的资料委托其催收记账卡相关费用等情形下，乙方不得因此主张甲方侵犯其个人隐私或商业秘密并提出索赔。</span>
    </div>
    <div class="agreement_item">
      <p class="mar_no">三、乙方的权利和义务</p>
      <span>1、乙方应提供办理ETC所需的资料，并保证所提供的全部资料真实、准确、完整、合法。乙方信息发生变更时，应在信息变更后再次使用前提供相应证明资料并及时向甲方提出变更申请。</span>
      <span>2、乙方应妥善保管电子标签和ETC记账卡，不得擅自拆卸、转租、转借或移用到其它车辆上使用。在使用过程中保证电子标签和ETC记账卡记载的车辆信息与登记使用的车辆一致、专车专用。若违反本约定甲方与高速公路经营管理单位有权拒绝提供相应服务。</span>
      <span>3、乙方可通过线下网点、线上互联网等途径查询高速公路通行、交易及消费信息。</span>
      <span>4、乙方认可和接受甲方所使用的电子收费系统交易数据的记载方式及准确性。</span>
      <span>5、乙方需遵守国家在高速公路通行的相关法律及规范要求。</span>
    </div>
    <div class="agreement_item">
      <p class="mar_no">四、电子标签和ETC记账卡使用约定</p>
      <div>
        <p class="mar_no">（一)一般约定</p>
        <div>
          <p class="mar_no">1、电子标签</p>
          <span>(1)电子标签需直接安装于车辆前挡风玻璃上，安装前需确认安装位置无其他附着物或裂痕。乙方应按甲方提供的操作流程进行安装和使用。</span>
          <span>(2)电子标签对外数据接口，一般作为制造商软件升级使用，未经厂商确认，严禁接入任何包括充电器在内的外部设备。否则可能造成产品损坏甚至电池爆炸等危险。</span>
          <span>(3)乙方应当按照本协议的约定使用电子标签，不得篡改、伪造或者以其它方式破译电子标签以逃避应付通行费。</span>
        </div>
        <div>
          <p class="mar_no">2、ETC账户</p>
          <span>(1)乙方完成ETC账户的开立程序，即获得了账号的使用权，乙方应妥善保管账号和密码，凭密码享受用户服务。</span>
          <span>(2)乙方应对所有使用其账号的交易行为负完全责任。</span>
          <span>①乙方账号遭到未获授权的使用，或者发生其它任何安全问题时，乙方应立即通知甲方，甲方配合乙方采取措施维护权益；</span>
          <span>②乙方需对使用账号的所有行为给甲乙双方或第三方造成的损害负全责，包括未保管好账号或密码的情形。</span>
          <span>(3)ETC记账卡可先使用后付费，通行费结算非实时划转，划转时间以扣款时间为准，如乙方有非正常使用或支付能力受到限制，甲方有权将乙方ETC账户以及账户下ETC记账卡列入限制状态名单，乙方在通过收费车道时该账户下ETC记账卡将不能使用，乙方需根据服务单位相关管理规定全额缴纳相关费用。乙方解除限制状态4小时后方可正常使用。</span>
          <span>(4)乙方同意提供甲方签约的银行等支付账户，用于划扣其名下ETC账户的相关费用。</span>
          <span>(5)如乙方签约第三方进行信用担保消费的，相关权利和义务遵从协议规定。</span>
        </div>
        <div>
          <p class="mar_no">3、ETC记账卡</p>
          <span>(1)乙方发现ETC记账卡损坏或无法正常使用的，应办理卡检测和卡更换。ETC卡因质量问题等非人为因素损坏的，可免费更换卡片，因刻划、折弯、缺损等物理损伤和异常高温塑性变形等人为损坏的，更换补办新卡需交纳工本费。</span>
          <span>(2)乙方遗失ETC记账卡，需办理挂失。ETC记账卡挂失自甲方受理乙方申请之时起4小时生效，挂失卡在挂失生效前所产生的消费金额，由乙方承担。挂失后可实时补办新卡，补办新卡需交纳工本费。</span>
        </div>
        <div>
          <span>4、乙方装有电子标签的车辆在ETC车道通行时，应按现场的标识、标线规定行驶，车速不得超过现场限速标志规定的时速，并与前车保持安全距离，按照车道信号灯提示通行。若不能正常通行，需停车配合现场工作人员处理。</span>
          <span>5、甲方或高速公路经营管理单位定期对电子收费系统进行维护维修，若因非甲方原因停电或设备故障等造成系统不能正常工作时，甲方不承担责任，乙方需根据服务单位相关管理规定以其他支付方式全额缴纳相关费用，同时乙方需妥善保存缴费票据，作为日后处理非现金交易的依据。</span>
        </div>
      </div>
      <div>
        <p class="mar_no">（二)特别约定</p>
        <span>1、若乙方提供伪造证件、发生少交或欠交通行费的行为，甲方有权通过下发限制状态名单方式停止乙方使用ETC账户及账户下ETC记账卡和电子标签，有权限制乙方行驶全国联网范围收费公路。同时按照甲方系统记载的消费记录缴纳少交或欠交的消费费用。</span>
        <span>2、电子标签和记账卡自发行之日起有效期为10年，到期后不能使用。如乙方需继续使用，需提前按规定办理延期事宜，如乙方未及时延期，因电子标签和记账卡到期不能使用引发损失，甲方不承担任何责任。</span>
        <span>3、电子标签和记账卡实行一车一卡一标签绑定使用，如发生车辆信息、联系方式等用户信息变更或车辆信息变更等情况，乙方应主动在产生通行费用前到甲方客服网点或通过甲方对外公布的线上渠道办理信息变更。</span>
        <span>4、车牌号所有人发生变动的，新的车牌号所有人有权申请挂起该车牌号所绑定的ETC记账卡和电子标签。ETC记账卡和电子标签挂起后将无法继续使用，需办理变更后方可继续使用。</span>
        <span>5、当甲方通过乙方所填写的客户资料中记载的联系方式无法联系到乙方时，甲方按该联系方式寄出的书面通知到达联系地址的，视为甲方通知到达。</span>
        <span>6、甲乙双方充分理解高速公路经营管理单位数据传输系统可能因通信繁忙出现延迟或因其他原因出现中断等情况，从而使交易中断或交易数据出现延迟，如造成上述情况岀现的原因非甲方所能控制，甲方不承担任何责任，但甲方可协助相关方解决。</span>
        <span>7、使用ETC记账卡缴纳收费公路通行费时，现场不开具纸质票据，通过全国收费公路通行费电子发票服务平台开具通行费电子发票。</span>
        <span>8、如乙方电子标签存在损坏导致无法读取信息、卡内车牌与实际不符、一车多签、限制状态名单等情形，乙方应配合现场工作人员引导处理。</span>
      </div>
    </div>
    <div class="agreement_item">
      <p class="mar_no">五、不可抗力</p>
      <span>因不可抗力原因导致本协议不能履行的，遇到不可抗力的一方免于承担责任。但遇到不可抗力的一方应在不可抗力发生后及时通知对方，并在【7】日内提供相关证明材料。除双方约定解除本协议外，不可抗力原因消除后，应恢复本协议的履行。</span>
    </div>
    <div class="agreement_item">
      <p class="mar_no">六、违约责任定义</p>
      <span>本协议中任何一方违反本协议内容的可视为违约，守约方可在法律许可的范围内阻止违约方的违约行为，并有权向违约方追索相关损失。</span>
      <span>乙方违反协议约定的，经甲方催告后应及时改正，拒不改正的，甲方有权解除本协议，乙方应当承担因违反约定造成的全部损失及其他法律责任。</span>
      <span>本协议所约定的甲方损失包括但不限于甲方经济利益的减损、甲方为证实乙方违约行为所支付的调查取证、公证费用、甲方为寻求法律救济所支付的诉讼费、保全费、律师代理费、咨询费和法院执行费用、调查取证费、差旅费等全部损失及费用。</span>
    </div>
    <div class="agreement_item">
      <p class="mar_no">七、争议解决</p>
      <span>有关本协议的争议适用中华人民共和国法律，与本协议及其执行有关的任何纠纷应通过友好协商予以解决。如果协商未果，可向甲方所在地人民法院起诉。</span>
    </div>
    <div class="agreement_item">
      <p class="mar_no">八、其他事项</p>
      <span>1、乙方或其代理人应具有完全民事行为能力，在签署本协议前乙方或其代理人已仔细阅读本协议，乙方或其代理人签署本协议后即视为完全理解并同意接受本协议的全部条款，本协议对双方均具有法律约束力。</span>
      <span>2、乙方或其代理人已仔细阅读并同意遵守《使用手册》中的相关约定，《使用手册》内容作为本协议附件与本协议具有同等法律效力。</span>
      <span>3、乙方所需办理的业务、手续以及收费标准请详见甲方的相关业务说明。</span>
      <span>4、甲方可根据业务扩展情况，适时对本协议及其附件内容进行修改，甲方将以公告或其他方式通知乙方。</span>
      <span>5、对于未办理电子标签的用户，本协议中有关电子标签的约定条款不适用。</span>
      <span>6、本协议内容包括但不限于联网公路通行费电子支付。</span>
      <span>7、本协议自双方签订之日起生效，有效期为5年，双方各执一份。协议到期后双方无异议自动顺延，每次顺延期限为1年。</span>
    </div>

    <!-- 继续办理按钮 -->
    <div class="transaction" @click="goTransaction">阅读完毕，同意协议，进行办理</div>
  </div>
</template>

<script>
import { axios } from "../../util/request";
import { log } from "util";
export default {
  data() {
    return {
      //登录地址
      urlPath:
        process.env.SSO_URL +
        "?appId=" +
        process.env.APP_ID +
        "&redirectUri=" +
        process.env.REDIRECTURI +
        "&responseType=code&scope=" +
        process.env.SCOPE +
        "&state=" +
        process.env.STATE +
        "&deviceId=" +
        process.env.DEVICEID,
    }
  },
  methods: {
    goTransaction() {
      // 判断用户是否登录
      // 检验本地用户是否已认证且本地有该用户身份证
      if (sessionStorage.getItem("TOKEN-ID") && sessionStorage.getItem("PHONE")) {
        // 检查用户是否实名认证
        axios.post('/User/CheckIsCertified',{userId: sessionStorage.getItem("USER-ID")}).then(data => {      
          if(1 === data.state){  
            // 检查用户是否有车辆信息
            axios.post('/Vehicle/CheckIsHasVehicle',{userId: sessionStorage.getItem("USER-ID")}).then(data => {
              if(1 === data.state){
                // 检查用户是否有预订单信息
                axios.post("/Order/CheckIsHasOrder",{userId: sessionStorage.getItem("USER-ID")}).then(data=>{
                  if(1===data.state){
                      this.$router.push({name:'vehicleDetection'});
                  }else{
                    this.$router.push({name:'mainProcess'});
                  }
                })
              }else{
                this.$router.push({name:'mainProcess'});
              }
            });                     
          } else {
            this.$router.push({name:'mainProcess'});
          }
        });  
      } else {
        this.noRegisterHint();
      }
    },
    // 如果用户没有登录，跳转到登录页面
    noRegisterHint() {
      console.log(this.urlPath);
      window.location.href = this.urlPath;
    },
  }
};
</script>
<style scoped lang='less'>
.container {
  height: 100%;
  width: 100%;
  background-color: #fff;
  text-align: left;
  box-sizing: border-box;
  padding: 3rem 1.5rem 1.5rem;
  color: #3a3b38;
  line-height: 1.3rem;
  font-size: 0.9rem;
  letter-spacing: 0.05rem;
  .agreement_item {
    margin-bottom: 1.3rem;
  }
  .theme {
    padding-bottom: 1rem;
    .agreement_title {
    color: #343532;
    font-weight: 600;
    }
    
  }
  p {
    margin-bottom: 1rem;
    text-indent: 0.6rem;
    margin-top: 1rem;
  }
  span {
    display: inline-block;
    text-indent: 0.6rem;
    text-align:justify;
    text-justify:inter-ideograph;
    margin-top: 0.6rem;
  }
  .legal {
    margin-bottom: 1rem;
  }
  .mar_no {
    margin-bottom: 0rem;
  }
  .transaction {
    height: 40px;
    width: 280px;
    line-height: 40px;
    border-radius: 20px;
    background-color: #fe0100;
    color: #fff;
    font-size: 16px;
    margin: 0 auto;
    text-align: center;
  }
}
</style>